const lenis = new Lenis({ smoothWheel: true, duration: 2, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), })
function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
requestAnimationFrame(raf)


gsap.registerPlugin(SplitText);
document.addEventListener("DOMContentLoaded", function () {
    // Blur reveal
    gsap.utils.toArray("[text-reveal]").forEach((element) => {
        const split = new SplitText(element, { type: "words" });
        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: element,
                start: "top 90%",
                end: "bottom 50%",
                toggleActions: "play none none none",
            },
        });
        tl.from(split.words, {
            y: "15%",
            skewX: "-15deg",
            // filter: "blur(8px)",
            opacity: 0,
            duration: 1,
            ease: "power1.inOut",
            stagger: window.innerWidth < 768 ? 0.15 : 0.075,
        });
    });
});



document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  const sections = gsap.utils.toArray("section");

  if (prefersReduced) {
    gsap.set("[data-fade]", { opacity: 1, y: 0 });
    return;
  }

  sections.forEach(section => {
    const items = section.querySelectorAll("[data-fade]");

    // Hide initially (JS-loaded safe)
    gsap.set(items, { opacity: 0, y: 60 });

    ScrollTrigger.batch(items, {
      start: "top 90%",
      once: true,

      onEnter: batch => {
        gsap.to(batch, {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power2.out",
          stagger: 0.1,
          overwrite: true
        });
      }
    });
  });

  // 🔑 THIS is what fixes mid-page refresh
  ScrollTrigger.refresh(true);
});
  

// ADD TO CART Button Price
document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  const variantInput = form.querySelector('input[name="id"]');
  const priceEl = form.querySelector('.btn-price');

  fetch(window.location.pathname + '.js')
    .then(res => res.json())
    .then(product => {

      function updateButtonPrice() {
        const variantId = Number(variantInput.value);
        const variant = product.variants.find(v => v.id === variantId);
        if (!variant) return;

        const formattedPrice = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 0, // Removes .00
          maximumFractionDigits: 0 //Ensures no decimals show
        }).format(variant.price / 100);

        priceEl.textContent = formattedPrice;
      }

      updateButtonPrice();

      const observer = new MutationObserver(updateButtonPrice);
      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ['value']
      });

      document.addEventListener('change', function (e) {
        if (e.target.closest('[name^="options"]')) {
          setTimeout(updateButtonPrice, 50);
        }
      });
    });
});


// Show more JS for text
document.addEventListener("DOMContentLoaded", () => {
  const WORD_LIMIT = 12;

  document.querySelectorAll(".product__description").forEach(el => {
    const fullText = el.textContent.trim();
    const words = fullText.split(/\s+/);

    if (words.length <= WORD_LIMIT) return;

    const shortText = words.slice(0, WORD_LIMIT).join(" ");

    let isExpanded = false;

    const render = () => {
      if (!isExpanded) {
        el.innerHTML = `
          ${shortText}
          <span class="dots">...</span>
          <span class="toggle-text" style="cursor:pointer;"> Read More</span>
        `;
      } else {
        el.innerHTML = `
          ${fullText}
          <span class="toggle-text" style="cursor:pointer;"> Show Less</span>
        `;
      }

      el.querySelector(".toggle-text").addEventListener("click", () => {
        isExpanded = !isExpanded;
        render();
      });
    };

    render();
  });
});



// cart drawer opening js
document.addEventListener('click', function (event) {
  // Check if the clicked element is our Add button
  const button = event.target.closest('.custom-ajax-add');
  if (!button) return;

  event.preventDefault();
  
  const variantId = button.getAttribute('data-variant-id');
  button.classList.add('loading'); // Optional: add a loading state

  let formData = {
    'items': [{
      'id': variantId,
      'quantity': 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) throw new Error('Network error');
    return response.json();
  })
  .then(cart => {
    // 1. Update the cart count bubble (if exists)
    document.dispatchEvent(new CustomEvent('cart:build'));
    
    // 2. Open the Drawer (Standard Dawn/Shopify method)
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // This is the standard way to trigger Dawn's drawer
      cartDrawer.classList.remove('is-empty');
      
      // We fetch the updated drawer content
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          document.querySelector('cart-drawer').innerHTML = html.querySelector('cart-drawer').innerHTML;
          
          // Open it
          cartDrawer.open();
        });
    } else {
      // Fallback: If no drawer, just go to cart
      window.location.href = '/cart';
    }
  })
  .catch((error) => {
    console.error('Error:', error);
    alert('Could not add to cart. Please try again.');
  })
  .finally(() => {
    button.classList.remove('loading');
  });
});


// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelectorAll('.btn-primary').forEach(btn => {
//     const text = btn.textContent.trim();
//     btn.textContent = '';

//     const wrap = document.createElement('div');
//     wrap.className = 'text-wrap';

//     const original = document.createElement('span');
//     original.className = 'text-line original';
//     original.textContent = text;

//     const clone = document.createElement('span');
//     clone.className = 'text-line clone';
//     clone.textContent = text;

//     wrap.appendChild(original);
//     wrap.appendChild(clone);
//     btn.appendChild(wrap);
//   });
// });
